export const GET_CHART_DATA = 'GET_CHART_DATA'
export const GET_REPORT_FILTERS_DATA = 'GET_REPORT_FILTERS_DATA'
export const GET_SETTINGS = 'GET_SETTINGS'
export const GET_SIGNATURE_UPLOAD_URL = 'GET_SIGNATURE_UPLOAD_URL'
export const UPDATE_SETTINGS = 'UPDATE_SETTINGS'
export const GET_COMPREHENSIVE_REPORT_FILTERS = 'GET_COMPREHENSIVE_REPORT_FILTERS'
export const GENERATE_COMPREHENSIVE_REPORT = 'GENERATE_COMPREHENSIVE_REPORT'
export const GET_CAIE_STATISTICS_FILTERS = 'GET_CAIE_STATISTICS_FILTERS'
export const GENERATE_CAIE_STATISTICS = 'GENERATE_CAIE_STATISTICS'
